"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLeaderboardScoresGql = exports.LeaderboardScoreGql = exports.GameApproveFlaggedLeaderboardScoreResponseGql = exports.ApproveFlaggedLeaderboardScoreInputGql = exports.GameDeleteUserLeaderboardScoreResponseGql = exports.DeleteUserLeaderboardScoreInputGql = exports.UserLeaderboardScoresInputGql = exports.APPROVE_FLAGGED_LEADERBOARD_SCORE_MUTATION = exports.DELETE_LEADERBOARD_SCORE_MUTATION = exports.LEADERBOARD_SCORES_QUERY = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.LEADERBOARD_SCORES_QUERY = (0, graphql_tag_1.default) `
  query GetLeaderboardScores($submissionId: String!, $input: UserLeaderboardScoresInput!) {
    me {
      id
      submission(id: $submissionId) {
        id
        leaderboardScores(input: $input) {
          nodes {
            userId
            username
            userCountryCode
            userCreatedAt
            userScore
            userRank
            seasonId
            createdAt
            updatedAt
            isFlagged
            flaggedAt
            flaggedReasons
          }
          count
          seasonId
          seasonEndDate
          pageInfo {
            hasNextPage
          }
        }
      }
    }
  }
`;
exports.DELETE_LEADERBOARD_SCORE_MUTATION = (0, graphql_tag_1.default) `
  mutation DeleteLeaderboardScore($input: DeleteUserLeaderboardScoreInput!) {
    developerGameDeleteLeaderboardScore(input: $input) {
      success
    }
  }
`;
exports.APPROVE_FLAGGED_LEADERBOARD_SCORE_MUTATION = (0, graphql_tag_1.default) `
  mutation ApproveFlaggedLeaderboardScore($input: ApproveFlaggedLeaderboardScoreInput!) {
    developerApproveFlaggedLeaderboardScore(input: $input) {
      success
    }
  }
`;
exports.UserLeaderboardScoresInputGql = (0, graphql_tag_1.default) `
  input UserLeaderboardScoresInput {
    gameId: String!
    offset: Int!
    limit: Int!
  }
`;
exports.DeleteUserLeaderboardScoreInputGql = (0, graphql_tag_1.default) `
  input DeleteUserLeaderboardScoreInput {
    gameId: String!
    userId: String!
    seasonId: String!
  }
`;
exports.GameDeleteUserLeaderboardScoreResponseGql = (0, graphql_tag_1.default) `
  type GameDeleteUserLeaderboardScoreResponse {
    success: Boolean!
  }
`;
exports.ApproveFlaggedLeaderboardScoreInputGql = (0, graphql_tag_1.default) `
  input ApproveFlaggedLeaderboardScoreInput {
    gameId: String!
    userId: String!
    seasonId: String!
  }
`;
exports.GameApproveFlaggedLeaderboardScoreResponseGql = (0, graphql_tag_1.default) `
  type GameApproveFlaggedLeaderboardScoreResponse {
    success: Boolean!
  }
`;
exports.LeaderboardScoreGql = (0, graphql_tag_1.default) `
  type LeaderboardScore {
    userId: String!
    username: String!
    userCountryCode: String
    userCreatedAt: DateTime!
    userScore: Float!
    userRank: Int!
    seasonId: String!
    createdAt: DateTime!
    updatedAt: DateTime!
    isFlagged: Boolean!
    flaggedAt: DateTime
    flaggedReasons: [String!]
  }
`;
exports.PageLeaderboardScoresGql = (0, graphql_tag_1.default) `
  type PageLeaderboardScores {
    nodes: [LeaderboardScore!]!
    count: Int!
    seasonId: String!
    seasonEndDate: DateTime
    pageInfo: PageInfo!
  }

  type PageInfo {
    hasNextPage: Boolean!
  }
`;
